<template>
  <el-dialog
    :title="type == 'add' ? '批量上传' : '批量修改'"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
    destroy-on-close
    :close-on-click-modal="false"
  >
    <el-form
      :model="dataForm"
      :rules="rules"
      ref="dataForm"
      label-width="110px"
    >
      <el-form-item label="组织架构:" prop="DepartmentId">
        <TenantCustomersSelectVue
          v-model="dataForm.DepartmentId"
          style="width: 100%"
          @change="changeCom"
        ></TenantCustomersSelectVue>
      </el-form-item>
      <el-form-item label="文件:" prop="list_">
        <el-button
          @click="upfile"
          icon="cloud-upload"
          type="primary"
          :disabled="!dataForm.DepartmentId"
          >上传文件</el-button
        >
        <span
          v-if="!dataForm.DepartmentId"
          style="color: #999; font-size: 12px; margin-left: 10px"
          >请先选择组织架构</span
        >
        <input
          type="file"
          id="file"
          accept=".xls,.xlsx"
          @change="beforeUpload"
          hidden
        />
        {{
          dataForm.list_.length > 0
            ? "已读取到：" + dataForm.list_.length + "条"
            : ""
        }}
        <div>
          你需要使用指定的模板文件才能正确导入!
          <el-button type="text" @click="download"
            ><u>下载号码导入模板</u></el-button
          >
        </div>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="ok" :loading="confirmLoading"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import TenantCustomersSelectVue from "@/components/TenantCustomersSelect.vue";
import { read, utils } from "xlsx";
export default {
  components: { TenantCustomersSelectVue },
  data() {
    return {
      type: "",
      dialogVisible: false,
      confirmLoading: false,
      tenantArr: [], //分公司列表
      companyIdForList: [], //客户列表
      dataForm: {
        DepartmentId: "",
        list_: [],
      },
      rules: {
        DepartmentId: {
          required: true,
          message: "请选择组织架构",
          trigger: "change",
        },
        list_: {
          required: true,
          message: "请上传文件",
          trigger: "change",
        },
      },
    };
  },
  methods: {
    init(type) {
      this.dialogVisible = true;
      this.type = type;
    },
    getComArr() {
      this.$http({
        url: "/api/TenantManager/GetAll",
        method: "get",
      }).then((res) => {
        this.tenantArr = res.data.response;
      });
    },
    //切换部门id
    changeCom(e) {
      //获取分公司下的客户
      this.$http({
        url:
          "/api/Common/Get?page=1&pageSize=500&key=&DepartmentId=" +
          this.dataForm.DepartmentId,
        method: "get",
      }).then((res) => {
        this.companyIdForList = res.data.response.data;
      });
    },
    handleClose() {
      this.$refs.dataForm.resetFields();
      this.dialogVisible = false;
    },
    ok() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          const list_ = this.dataForm.list_.map((v) => {
            return {
              ...v,
              DepartmentId: this.dataForm.DepartmentId,
            };
          });
          this.confirmLoading = true;
          this.$http({
            url:
              this.type == "add"
                ? "/api/TelListLog/AddTelEntites"
                : "/api/TelListLog/ModifyTelInfo",
            method: "post",
            data: list_,
          })
            .then((res) => {
              if (res.data && res.data.success) {
                this.confirmLoading = false;
                console.log(res);
                this.$message.success(res.data.msg);
                this.handleClose();
                this.$emit("ok");
              }
            })
            .catch((err) => {
              this.confirmLoading = false;
              console.log(err.response.data.error.message);
              this.$confirm({
                title: "录入异常提示",
                content: err.response.data.error.message,
                okText: "我知道了",
                okType: "danger",
                cancelText: false,
                onOk() {
                  console.log("OK");
                },
              });
            });
        }
      });
    },
    upfile() {
      const input = document.querySelector("#file");
      input.click();
    },
    beforeUpload(e) {
      this.readExcel(e);
      e.srcElement.value = "";
    },
    /**
     * 下载模板
     */
    download() {
      const url = "/过滤切换模板.xlsx";
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    /**
     * e 文件event
     * type 类型add新增update修改
     */
    readExcel(e) {
      var that = this;
      const files = e.target.files;
      // 如果没有文件名
      if (files.length <= 0) {
        return false;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.$Message.error("上传格式不正确，请上传xls或者xlsx格式");
        return false;
      }
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          // 切换为新的调用方式
          const workbook = read(data, {
            type: "binary",
          });
          // 取第一张表
          const wsname = workbook.SheetNames[0];
          // 切换为新的调用方式 生成json表格内容
          const ws = utils.sheet_to_json(workbook.Sheets[wsname]);
          this.uploadArray(ws);
          // 后续为自己对ws数据的处理
        } catch (e) {
          return false;
        }
      };
      fileReader.readAsBinaryString(files[0]);
    },
    /**
     * list 列表
     */
    uploadArray(list) {
      console.log(list);
      let msg = "";
      let list_ = [];
      for (var i = 0; i < list.length; i++) {
        const v = list[i];
        console.log(v);
        if (
          v.客户公司名字 === "" ||
          v.客户公司名字 === undefined ||
          v.客户公司名字 === null
        ) {
          msg = `第${i + 1}行的【客户公司名字】数据异常，请检查`;
          break;
        }
        //查询客户名称是否存在在数据库中
        const index = this.companyIdForList.findIndex(
          (item) => item.Name === v.客户公司名字
        );
        if (index == -1) {
          msg = `第${
            i + 1
          }行的【客户公司名字】不在系统中，请检查是否输入正常，或添加此客户公司名字【 ${
            v.客户公司名字
          }】`;
          break;
        }
        if (
          v.所属运营商 === "" ||
          v.所属运营商 === undefined ||
          v.所属运营商 === null
        ) {
          msg = `第${i + 1}行的【所属运营商】数据异常，请检查`;
          break;
        }
        if (
          v.手机号码 === "" ||
          v.手机号码 === undefined ||
          v.手机号码 === null
        ) {
          msg = `第${i + 1}行的【手机号码】数据异常，请检查`;
          break;
        }
        if (
          v.是否启用 === "" ||
          v.是否启用 === undefined ||
          v.是否启用 === null
        ) {
          msg = `第${i + 1}行的【是否启用】数据异常，请检查`;
          break;
        }
        if (
          v.是否白名单 === "" ||
          v.是否白名单 === undefined ||
          v.是否白名单 === null
        ) {
          msg = `第${i + 1}行的【是否白名单】数据异常，请检查`;
          break;
        }
        list_.push({
          Tel: v.手机号码 + "",
          CompanyName: v.客户公司名字 + "",
          CompanyId: this.companyIdForList[index].Id,
          SupplierName: v.所属运营商 + "",
          IsEnabled: v.是否启用 == "启用" ? true : false,
          IsWhitelist: v.是否白名单 == "启用" ? true : false,
          ICCID: !!v.ICCID ? v.ICCID + "" : "",
          CityName: !!v.市 ? v.市 : "",
          ProvinceName: !!v.省 ? v.省 : "",
          Remark: !!v.备注 ? v.备注 + "" : "",
        });
      }
      if (msg) {
        return this.$message.error(msg);
      }
      this.dataForm.list_ = list_;
      this.$refs.dataForm.validateField("list_");
    },
  },
};
</script>

<style>
</style>